import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";
import { ChartName, DefaultDate } from "src/components/Referral-partner/Analytics/analyticsTypes";

export interface RPAnalyticsState {
  chartDateRange: Record<ChartName, DefaultDate>;
}

const initialState: RPAnalyticsState = {
  chartDateRange: {
    referralConversions: "ALL",
    referralfees: "ALL",
    growthHistory: "ALL",
    coinsVisited: "ALL",
    referralHoldings: "ALL",
    tradinghistory: "ALL",
    depositVolume: "ALL",
    timeToFirstTrade: "ALL",
    assetsTraded: "1Y",
  },
};

const RPAnalticsSlice = createSlice({
  name: "RPAnalytics",
  initialState,
  reducers: {
    changeGlobalDate: (state, action: PayloadAction<DefaultDate>) => {
      Object.entries(state.chartDateRange).forEach(([key, _]) => {
        state.chartDateRange[key as ChartName] = action.payload;
      });
    },
    changeChartDate: (state, action: PayloadAction<Record<ChartName, DefaultDate>>) => {
      state.chartDateRange = { ...state.chartDateRange, ...action.payload };
    },
  },
});

export default RPAnalticsSlice;

export const useRPAnalyticsState = (): RPAnalyticsState =>
  useAppSelector((state): RPAnalyticsState => state.RPAnalytics);

export const { changeGlobalDate, changeChartDate } = RPAnalticsSlice.actions;
